import { useSearchParams } from 'react-router-dom';

const emptyParams = new URLSearchParams();
const noop = () => { };
const ssrFallback = [emptyParams, noop];

/**
 * SSR-safe wrapper around useSearchParams.
 * During SSR (no Router context), useSearchParams throws — this hook
 * catches that and returns [empty URLSearchParams, no-op setter] instead.
 *
 * On the client (inside BrowserRouter), this is a transparent passthrough.
 */
const useSafeSearchParams = () => {
    try {
        return useSearchParams();
    } catch {
        return ssrFallback;
    }
};

export default useSafeSearchParams;
